export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlTLogQuery: function smartControlTLogQuery(controlId, data) {
      return request({
        url: "/iot/smartControlTLog/".concat(controlId, "/query"),
        method: 'get',
        params: data
      });
    }
  };
});